import { render, staticRenderFns } from "./CommonEhrFiles.vue?vue&type=template&id=60a57b34&scoped=true"
import script from "./CommonEhrFiles.vue?vue&type=script&lang=js"
export * from "./CommonEhrFiles.vue?vue&type=script&lang=js"
import style0 from "./CommonEhrFiles.vue?vue&type=style&index=0&id=60a57b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a57b34",
  null
  
)

export default component.exports